import styled from 'styled-components';

import { TextField as MuiTextField } from '@mui/material';

const Input = styled(MuiTextField)`
  && {
    margin: 0;
    width: 100%;
    .MuiFormHelperText-root {
      white-space: nowrap;
      margin: 0;
    }
    .MuiOutlinedInput-multiline {
      padding: 0;
    }
    .MuiOutlinedInput-root {
      min-height: 40px;
      ${(props) => props.multiline && `height: auto !important;`}
      padding: 0;
      min-height: 40px;
      background-color: ${({theme}) => theme.palette.colors.white};
    }
    .MuiInputBase-input {
      border-radius: 5px;
      background-color: ${(props) => props.theme.palette.common.white};
      font-size: 16px;
      padding: 0 6px;
      box-sizing: border-box;
    }
    fieldset {
      top: 0;
      border-radius: 5px;
      border-color: ${({theme}) => theme.palette.colors.gray200};
    }
    legend {
      display: none;
    }
    .MuiInputAdornment-positionEnd {
      position: absolute;
      right: 10px;
    }
  }
`;

export default Input;
